class ColorSchemeStorage {
    constructor(key, defaultScheme) {
        this.key = key;
        this.defaultScheme = defaultScheme;
    }
    retrieve() {
        const storedScheme = window.localStorage.getItem(this.key);
        return storedScheme !== null ? storedScheme : this.defaultScheme;
    }
    store(scheme) {
        if (scheme === this.defaultScheme) {
            window.localStorage.removeItem(this.key);
        }
        else {
            window.localStorage.setItem(this.key, scheme);
        }
    }
}
export { ColorSchemeStorage };
